import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  fundingPotentialAmountTitle: {
    id: "funding-application: potential funding amount title",
    defaultMessage: "You could get up to",
  },
  fundingPotentialAltTitle: {
    id: "funding-application: potential funding alt title",
    defaultMessage: "All set, let's connect your accounts",
  },
  continueToConnectionsLabel: {
    id: "funding-application: Continue to account connections",
    defaultMessage: "Continue to account connections",
  },
  additionalInfo: {
    id: "funding-application: funding eligibility generic additional info",
    defaultMessage: "This estimate is based on your previous responses and subject to a final underwriting decision.",
  },
});
